const WEB_PUSH_KEY = process.env.NEXT_PUBLIC_WEB_PUSH_KEY;

export class NotificationService {
  private swRegistration: ServiceWorkerRegistration | null = null;

  public async init(): Promise<void> {
    if ("serviceWorker" in navigator && "PushManager" in window) {
      try {
        const reg = await navigator.serviceWorker.register("/service-worker.js");
        this.swRegistration = reg;
      } catch (error) {
        console.error("Service Worker registration failed:", error);
      }
    }
  }

  public async requestPermission(): Promise<NotificationPermission> {
    if (!("Notification" in window)) {
      throw new Error("This browser does not support desktop notification");
    }
    return await Notification.requestPermission();
  }

  public async subscribeToPush(): Promise<PushSubscription | null> {
    const permission = await this.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission denied");
      return null;
    }

    if (!this.swRegistration) {
      console.error("Service Worker not registered");
      return null;
    }

    try {
      const subscription = await this.swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: WEB_PUSH_KEY,
      });
      return subscription;
    } catch (error) {
      console.error("Failed to subscribe to push notifications:", error);
      return null;
    }
  }

  public async getSubscription(): Promise<PushSubscription | null> {
    if (!this.swRegistration) return null;
    return await this.swRegistration.pushManager.getSubscription();
  }

  public async unsubscribe(): Promise<boolean> {
    const subscription = await this.getSubscription();
    if (subscription) {
      return await subscription.unsubscribe();
    }
    return false;
  }
}

export const notificationService = new NotificationService();
